import $ from 'jquery';
import datepickerFactory from 'jquery-datepicker';
import { LocationApi } from '../api/apicollection';

export default function CheckOutViewModel() {
    datepickerFactory($);

    this.location = ko.observable();
    let isReservation = $('#IsReservation').val() === 'True';
    let isTaxExempt = $('#IsTaxExempt').val() === 'True';

    this.Load = () => {
        $('#processing').hide();
        LocationApi.getLocationData().then(data => {
            let location = data.data;
            this.location(location);

            if (location.alternateContactRequired) {
                $('#AltContactFirstname').attr('required', 'required');
                $('#AltContactLastname').attr('required', 'required');
                $('#AltContactPhoneNumber').attr('required', 'required');
            }

            if (!isReservation && location.alternateContactAddressRequired) {
                $('#AltContactAddress').attr('required', 'required');
                $('#AltContactCity').attr('required', 'required');
                $('#AltContactState').attr('required', 'required');
                $('#AltContactZip').attr('required', 'required');
            }
        });

        $('#paymentButton').on('click', function () {
          $('#paymentButton').hide();
          $('#processing').show() ;
        })
    }
    this.Load();

    $('#ExpirationDate').datepicker({
        changeMonth: true,
        changeYear: true,
        dateFormat: 'mm/yy',
        showButtonPanel: true,
        monthNames:      ['1','2','3','4','5','6','7','8','9','10','11','12'],
        monthNamesShort: ['1','2','3','4','5','6','7','8','9','10','11','12'],
        yearRange: '2020:2035',
        onClose: function(dateText, inst) {
            $(this).val($.datepicker.formatDate('mm/yy', new Date(inst.selectedYear, inst.selectedMonth, 1)));
        }
    });

    $('#ExpirationDate').focus(function () {
        $('.ui-datepicker-current').hide();
        $('.ui-datepicker-calendar').hide();
        $('.ui-datepicker-buttonpane').css('text-align','center');
        $('.ui-datepicker-year').css('width','auto');
        $('.ui-datepicker-month').css('width','auto');
        $('.ui-datepicker-close').css('float','none');
        $('#ui-datepicker-div').css('width','auto');
        $('#ui-datepicker-div').position({
            my: 'center top',
            at: 'center bottom',
            of: $(this)
        });
    });

    if (isTaxExempt) {
        $('#TaxExemptNumber').attr('required', 'required');
    }
    else {
        $('.billing-row__tax-exempt').css('display', 'none');
    }

    return this;
}